
import { ReactNode } from "react";

interface ProcessStepProps {
  number: number;
  title: string;
  description: string;
  bulletPoints: string[];
  testimonial: string;
  testimonialAuthor?: string;
}

export const ProcessStep = ({ 
  number, 
  title, 
  description, 
  bulletPoints, 
  testimonial,
  testimonialAuthor
}: ProcessStepProps) => {
  return (
    <div className="relative flex flex-col sm:flex-row group hover:scale-[1.01] transition-all duration-300">
      <div className="sm:w-12 flex-shrink-0">
        <div className="w-12 h-12 bg-edgefi-purple rounded-full flex items-center justify-center text-white font-bold shadow-lg z-10 relative group-hover:bg-edgefi-purple/90 transition-colors duration-300">{number}</div>
      </div>
      <div className="mt-4 sm:mt-0 sm:ml-8 bg-white p-6 rounded-xl shadow-sm border border-gray-100 group-hover:border-edgefi-purple/20 group-hover:shadow-md transition-all duration-300">
        <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
        <p className="text-gray-600 mb-4">
          {description}
        </p>
        <ul className="space-y-2">
          {bulletPoints.map((point, index) => (
            <li key={index} className="flex items-start gap-2">
              <div className="min-w-4 h-4 w-4 rounded-full bg-edgefi-purple/10 flex-shrink-0 mt-1 group-hover:bg-edgefi-purple/20 transition-colors duration-300"></div>
              <span className="text-gray-700">{point}</span>
            </li>
          ))}
        </ul>
        <div className="mt-4 p-3 bg-edgefi-purple/5 rounded-lg border border-edgefi-purple/10">
          <p className="text-gray-600 italic text-sm">
            "{testimonial}"
            {testimonialAuthor && <span className="text-sm not-italic block mt-2">— {testimonialAuthor}</span>}
          </p>
        </div>
      </div>
    </div>
  );
};
